import BaseApi from '@/api/Base/BaseApi'
import {
  CreateDataStreamingNodePayload,
  DataStreamingNodeInfo,
  UpdateDataStreamingNodeSettingsPayload
} from '@/api/DataStreamingNode/types'
import { CommonListPayload } from '@/api/Node/types'
import { DatasetNodeItemListResponse } from '@/api/DatasetNode/types'

const ROOT = '/dataStreaming'

const defaultPaginationOptions = {
  itemsPerPage: 40,
  page: 0,
  sortDir: 'desc',
  sortKey: 'createdAt',
}

export default class DataStreamingNodeApi extends BaseApi {
  createDataStreamingNode(payload: CreateDataStreamingNodePayload) {
    const { projectId, ...rest } = payload
    return this.agent.post<DataStreamingNodeInfo>(`/project/${projectId}/dataStreaming/create`, rest)
  }

  getDataStreamingNode(dataStreamingNodeId: string) {
    return this.agent.get<DataStreamingNodeInfo>(`${ROOT}/${dataStreamingNodeId}`)
  }

  updateDataStreamingNodeSettings(payload: UpdateDataStreamingNodeSettingsPayload) {
    const { dataStreamingNodeId, ...rest } = payload
    return this.agent.put<DataStreamingNodeInfo>(`${ROOT}/${dataStreamingNodeId}`, rest)
  }

  getDataStreamingItems(dataStreamingNodeId: string, options?: CommonListPayload) {
    const { itemsPerPage = 40, page = 0, sortDir = 'asc', sortKey = 'createdAt' } = options ?? {}
    return this.agent.get<DatasetNodeItemListResponse>(`${ROOT}/${dataStreamingNodeId}/items`, {
      params: {
        page,
        num_per_page: itemsPerPage,
        sort_key: sortKey,
        sort_dir: sortDir,
      },
    })
  }
}
